export default __webpack_public_path__ + "static/media/coach_meter_mg@3x.4b4ce80e.webp";